import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1.847 20c-.527 0-.966-.171-1.318-.513A1.718 1.718 0 0 1 0 18.206V6.239c0-.511.176-.938.53-1.28.352-.342.791-.514 1.317-.515H4V3.89c0-1.08.389-1.998 1.167-2.755C5.945.378 6.889 0 8 0c1.11 0 2.055.378 2.833 1.134C11.611 1.891 12 2.81 12 3.89v.555h2.154c.526 0 .965.172 1.317.515s.528.77.529 1.281v11.966c0 .51-.176.938-.53 1.28-.352.344-.79.515-1.316.514H1.847Zm0-1.111h12.307a.683.683 0 0 0 .484-.213c.147-.143.22-.3.22-.472V6.24a.649.649 0 0 0-.22-.471.676.676 0 0 0-.485-.213H12v2.777a.53.53 0 0 1-.163.397.562.562 0 0 1-.408.159.562.562 0 0 1-.408-.159.53.53 0 0 1-.164-.397V5.556H5.143v2.777a.53.53 0 0 1-.164.397.562.562 0 0 1-.408.159.562.562 0 0 1-.408-.159A.53.53 0 0 1 4 8.333V5.556H1.847a.684.684 0 0 0-.485.213.64.64 0 0 0-.22.471v11.966c0 .17.074.327.22.47a.675.675 0 0 0 .484.213M5.143 4.444h5.714V3.89c0-.782-.275-1.44-.825-1.976-.55-.534-1.227-.802-2.032-.802-.805 0-1.482.268-2.032.802-.55.535-.825 1.194-.825 1.976v.555Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }